<div class="label" [ngClass]="statusClass">
  <div class="label__dot"></div>
  <div class="label__name">{{ text | translate }}</div>
</div>
